/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

const handleOnClick = (event) => {
    const { target } = event;

    if (target.selectionEnd <= 2) {
        target.setSelectionRange(2, 2);
    } else {
        const valueSelected = target.value.substring(0, target.selectionEnd);
        const match = valueSelected.match(/\d/gi);
        if (match) {
            let lastDigitIndexInSelection = valueSelected.lastIndexOf(match[match.length - 1]) + 1;
            if (
                target.value
                    .substring(
                        lastDigitIndexInSelection,
                        lastDigitIndexInSelection + 1,
                    )
                    .match(/[\s]/)
            ) {
                lastDigitIndexInSelection += 1;
            }
            target.setSelectionRange(
                lastDigitIndexInSelection,
                lastDigitIndexInSelection,
            );
        }
    }
};

const GiftListCustomerNumberMask = (props) => {
    const { inputRef, 'data-props': customProps, ...other } = props;
    const { maskRegEx } = customProps ?? {};
    return (
        <MaskedInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={maskRegEx}
            placeholderChar={'\u2000'}
            onClick={(event) => handleOnClick(event)}
        />
    );
};

GiftListCustomerNumberMask.propTypes = {
    inputRef: PropTypes.func.isRequired,
    'data-props': PropTypes.object.isRequired,
};

export default GiftListCustomerNumberMask;
